/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Highlight_Starter_ConnectorsInputs */



/**
* | output |
* | --- |
* | "External connectors (Google Drive, OneDrive, GitHub)" |
*
* @param {Plan_Gate_Highlight_Starter_ConnectorsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_highlight_starter_connectors = /** @type {((inputs?: Plan_Gate_Highlight_Starter_ConnectorsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Highlight_Starter_ConnectorsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Externe Konnektoren (Google Drive, OneDrive, GitHub)")
	return /** @type {LocalizedString} */ ("External connectors (Google Drive, OneDrive, GitHub)")
});